module.exports = __WEBPACK_EXTERNAL_MODULE_6__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"js-data-http","commonjs":"js-data-http","commonjs2":"js-data-http","root":"JSDataHttp"}
// module id = 6
// module chunks = 0